import ProfileDialog from './dialogs/profile'

export default {
  namespaced: true,
  modules: {
    profile: ProfileDialog
  }
}
